import * as React from "react";
import styles from "./secondPSP.module.scss";
import NextBackButtons from "../../../../molecules/nextBackButtons/nextBackButtons";

import { connect } from "react-redux";
import { setHome } from "../../../../../../redux/actions/currentPage.actions";
import {
  setFirstAfterType,
  setThird,
} from "../../../../../../redux/actions/requestStage.actions ";

import {
  Decrement,
  Increment,
} from "../../../../../../redux/actions/progressBarStatus.actions";
import RequestTypeName from "../../logic/requestTypeName.bs";
import { MdPayments } from "react-icons/md";
import Dropzone from "react-dropzone";
import { IoIosAddCircleOutline } from "react-icons/io";
import { IdPspNavigation } from "../../../../../../interfaces/serviceModels/IRequestJSON";
import { setPspContentObject } from "../../../../../../redux/actions/pspContentObject.actions";
import { useEffect, useState } from "react";
import {
  AnonymousCredential,
  BlobServiceClient,
  BlobUploadCommonResponse,
} from "@azure/storage-blob";
import { addFileName } from "../../../../../../redux/actions/fileNames.actions";

function SecondPSP(props: any) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  let requestTypeName = RequestTypeName(props.requestType);
  const [apiDescription, setApiDescription] = useState<string>(
    props.pspContentObject.idApiDescriptionSetNavigation.apiDescription
  );

  //File Upload Handler
  const AccountName = "requestpoint";
  const SasToken =
    "?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2027-03-01T17:10:28Z&st=2024-02-21T09:10:28Z&spr=https,http&sig=Qy0uW5EVw2fRg2%2F1LZerWZp4WAeY3C%2BbaZGBpgCysXU%3D";
  const ContainerName = "requestfiles";

  const inputFile = React.useRef<HTMLInputElement | null>(null);

  const [file, setFile] = useState<File | null>(null);
  const [isFileUploaded, setIsFileUploaded] = useState<Boolean>(false);
  const [uploadingError, setUploadingError] = useState<string | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setFile(event.target.files[0]);
    }
  };

  const handleUpload = async () => {
    if (file) {
      try {
        const anonymousCredential = new AnonymousCredential();
        const blobServiceClient = new BlobServiceClient(
          `https://${AccountName}.blob.core.windows.net?${SasToken}`,
          anonymousCredential
        );

        // Create a container client
        const containerClient =
          blobServiceClient.getContainerClient(ContainerName);

        // Check if the container exists
        const containerExists = await containerClient.exists();
        if (!containerExists) {
          // Create the container if it does not exist
          await containerClient.create();
        }

        // Encode the file as a Base64 string
        const fileReader = new FileReader();
        fileReader.onloadend = async () => {
          // Upload the file to Azure Blob Storage
          const filePath = `${props.stakeholders.requestingPerson}/${props.requestObject.requestLabel}/${props.requestObject.creationDate}/apides-${file.name}`;
          const blockBlobClient = containerClient.getBlockBlobClient(filePath);

          const response: BlobUploadCommonResponse =
            await blockBlobClient.uploadData(file);

          console.log(`File "${file.name}" uploaded to Azure Blob Storage.`);
          setIsFileUploaded(true);
          props.addFileName(file.name);
        };
        fileReader.readAsBinaryString(file);
      } catch (error) {
        console.error("Error uploading file:", error);
        setUploadingError(`Error uploading file: ${error}`);
      }
    }
  };

  React.useEffect(() => {
    handleUpload();
  }, [file]);

  return (
    <>
      <div className={styles.stageTitleContainer}>
        <MdPayments className={styles.requestStageIcon} />
        <h5>API Description</h5>
      </div>
      <div className={styles.requestContentContainer}>
        <div className={styles.inputContainer}>
          <div className={styles.inputColumn}>
            <h4>PSP API documentation (URL)</h4>
            <p>
              The payment provider must provide to SKIDATA integrator an API
              documentation of their payment service that contains:
            </p>
            <p>
              Technical protocol description e.g., documentation URL A detailed
              description of each use-case of the payment workflow:
            </p>
            <ul>
              <li>
                The sequence of API calls/messages showing source & destination.
              </li>
              <li>
                The full sequence including authorisation followed by capture.
              </li>
              <li>
                Workflows for each and all possible payment methods if these
                differ from each other e.g., credit cards, debit cards, phone
                number, wallets or other.{" "}
              </li>
              <li>
                For each integration method possible e.g., API-level, embedded
                UI control, PSP hosted checkout form, or any combination. Note:
                SKIDATA integrates using Java code, not e-commerce tools.
              </li>
              <li>
                Workflows for all edge-cases and error cases including:{" "}
                <ul>
                  <li>User cancellation during payment.</li>
                  <li>
                    PSP cancellation in case of system error or payment
                    rejection.
                  </li>
                  <li>
                    Cancellation/reversal by SKIDATA on product delivery
                    failure.
                  </li>
                </ul>
              </li>
              <li>
                Description of each API method or at least the relevant one:
                <ul>
                  <li>Optional and mandatory parameters.</li>
                  <li>Possible and expected parameter values & ranges.</li>
                  <li>
                    Return codes (for success and especially for all error
                    situations).
                  </li>
                  <li>
                    A full list of return/error codes and their meanings, also
                    appropriate user response texts if SKIDATA must display a
                    response (localised).
                  </li>
                </ul>
              </li>
            </ul>

            <textarea
              value={apiDescription}
              onChange={(e) => setApiDescription(e.target.value)}
            />
          </div>
          <div className={styles.inputColumn}>
            <h4>PSP API documentation (file)</h4>
            <p>Please upload any relevant documents.</p>
            <Dropzone
              onDrop={(acceptedFiles) => {
                console.log(acceptedFiles);
                setFile(acceptedFiles[0]);
                handleUpload();
              }}
            >
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()} className={styles.dropzone}>
                  <input {...getInputProps()} />
                  <div className={styles.dropBoxIconWrapper}>
                    <IoIosAddCircleOutline />
                  </div>
                  <p>Drag 'n' drop some files here, or click to select files</p>
                </div>
              )}
            </Dropzone>
            <p className={styles.addedFillesText}>Added File:</p>
            <ul>
              {isFileUploaded ? <li>{file?.name}</li> : <li>No files</li>}
            </ul>
            {isFileUploaded && <p>File has been successfully uploaded. </p>}
            {uploadingError && <p>{uploadingError}</p>}
          </div>
        </div>
      </div>
      <NextBackButtons
        next={() => {
          props.Increment();
          props.setThird();
          props.setPspContentObject({
            idApiDescriptionSetNavigation: { apiDescription: apiDescription },
          });
        }}
        back={() => {
          props.setFirstAfterType();
          props.Decrement();
        }}
      />
    </>
  );
}

const mapStateToProps: any = (state: any) => {
  return {
    requestType: state.requestType,
    pspContentObject: state.pspContentObject,
    requestObject: state.requestObject,
    stakeholders: state.stakeholders,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    setHome: () => dispatch(setHome()),
    setFirstAfterType: () => dispatch(setFirstAfterType()),
    setThird: () => dispatch(setThird()),
    setPspContentObject: (pspObject: IdPspNavigation) =>
      dispatch(setPspContentObject(pspObject)),
    Increment: () => dispatch(Increment()),
    Decrement: () => dispatch(Decrement()),
    addFileName: (fileName: string) => dispatch(addFileName(fileName)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SecondPSP);
